/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_OrdersInputs */

const vi_shop_account_col_orders = /** @type {(inputs: Shop_Account_Col_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số đơn`)
};

/**

* @param {Shop_Account_Col_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_orders = /** @type {((inputs?: Shop_Account_Col_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_orders(inputs)
});